/**
 * Determine if the current locale is English.
 * Prefers langId from application context string when available, otherwise uses navigator.language.
 * Treats langId of '-1' or values starting with 'en' as English.
 * Defaults to true (English) if unable to determine.
 *
 * @param {string|null} appContextString - JSON string from applicationContextVar, or null/undefined
 * @returns {boolean} true if English locale, false otherwise
 */
export const isEnglishLocale = (appContextString) => {
  try {
    const parsed = appContextString ? JSON.parse(appContextString) : null;
    const { langId } = parsed || {};

    if (typeof langId === 'string') {
      const lower = langId.toLowerCase();
      return (langId === '-1') || lower.startsWith('en');
    }

    const navLang = typeof navigator !== 'undefined' ? navigator.language : null;
    return typeof navLang === 'string' ? navLang.toLowerCase().startsWith('en') : true;
  } catch (e) {
    const navLang = typeof navigator !== 'undefined' ? navigator.language : null;
    return typeof navLang === 'string' ? navLang.toLowerCase().startsWith('en') : true;
  }
};
